module.exports = __webpack_public_path__ + "static/img/solution_img_socialcogovernance_1.a632db5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/solution_img_socialcogovernance_1.png
// module id = qLYi
// module chunks = 0